import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { EntityTypeFilterValue } from "../../../../legacy/types/companyFilter";
import { ProductTableQueryPayload } from "../../../../types/taxonomy";
import { PRODUCT_TABLE_QUERY } from "../queries/productTableQuery";
import { COMPANY_SEARCH_CLIENT } from "../../../../utils/consts";

export const useProductTableQuery = (
  vendorId: number,
  localizeInstalls: boolean,
  entityTypeFilterValue: EntityTypeFilterValue
) => {
  const { data, loading } = useQuery<ProductTableQueryPayload>(
    PRODUCT_TABLE_QUERY,
    {
      variables: {
        vendorId,
        localizeInstalls,
        ...entityTypeFilterValue,
      },
      skip: vendorId === 0,
      context: { clientName: COMPANY_SEARCH_CLIENT },
    }
  );

  const results = useMemo(
    () => data?.productCatalogInstallsProducts || [],
    [data]
  );

  return { results, loading };
};
